import { Button, Divider, Theme, Typography, CircularProgress } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { COLOR_PRIMARY } from '../../routes/color-constants'
import {
  URL_APPLICATION_NEW,
  URL_APPLICATIONS,
  URL_CLIENTS_ID,
  URL_CONTACT,
  URL_HELP,
  URL_NEWCLIENT,
} from '../../routes/routes-constants'
import home from '../../assets/Iconos_muestras/inicio-inact.svg'
import client from '../../assets/Iconos_muestras/clientes-inac.svg'
import solicitud from '../../assets/Iconos_muestras/solicitudes-inac.svg'
import ayuda from '../../assets/Iconos_muestras/ayuda-inac.svg'
import estadisticas from '../../assets/Iconos_muestras/estadisticas.svg'

export interface TitleProps {
  title: string
  color?: string
  saveDraft?: () => void
  saveDraftAgain?: () => void
  fatherId?: string
}

export const Title = (props: TitleProps) => {
  const classes = useStyles(props)
  const { t, ready } = useTranslation()
  const navigate = useNavigate()

  if (!ready) return <CircularProgress />

  const imageSwitch = () => {
    let value
    switch (props.title) {
      case t('Home'):
        value = home
        break
      case t('Help'):
        value = ayuda
        break
      case t('createFaq'):
        value = ayuda
        break
      case t('clients'):
        value = client
        break
      case t('ApplicationsNew'):
        value = solicitud
        break
      case t('clients') + ' / ' + t('Applications'):
        value = solicitud
        break
      case t('contact'):
        value = ayuda
        break
      case t('ApplicationsDetail'):
        value = solicitud
        break
      case t('ApplicationsDetail2'):
        value = solicitud
        break
      case t('ApplicationsManage'):
        value = solicitud
        break
      case t('statistics'):
        value = estadisticas
        break
      default:
        value = solicitud
        break
    }
    return value
  }

  const handleClientsButton = () => {
    if (props.fatherId) {
      navigate(`${URL_CLIENTS_ID.replace(':id', 'create')}?father=${props.fatherId}`)
    } else {
      navigate(URL_NEWCLIENT)
    }
  }

  return (
    <>
      <div className={classes.header}>
        <div className={classes.headerImage}>
          <img src={imageSwitch()} alt={props.title} />
          <Typography className={classes.title} variant={'h3'} align="left">
            {props.title}
          </Typography>
        </div>

        {props.title == t('Home') ? (
          <Button
            className={classes.button}
            variant={'contained'}
            onClick={() => navigate(URL_APPLICATION_NEW)}
            style={{ float: 'right' }}>
            {t('newRequest').toUpperCase()}
          </Button>
        ) : props.title == t('ApplicationsNew') ? (
          <>
            <div style={{ width: '50%' }}>
              <Button
                className={classes.button}
                variant="contained"
                onClick={() => props.saveDraft?.()}
                style={{ float: 'right' }}>
                {t('saveDraft').toUpperCase()}
              </Button>
              <Button
                className={classes.buttonSecondary}
                variant={'contained'}
                onClick={() => navigate(URL_APPLICATIONS)}
                style={{ marginLeft: '50%' }}>
                {t('cancel').toUpperCase()}
              </Button>
            </div>
          </>
        ) : props.title == t('ApplicationsDetail') ? (
          <Button
            className={classes.button}
            variant={'contained'}
            onClick={() => props.saveDraftAgain?.()}
            style={{ float: 'right' }}>
            {t('Edit').toUpperCase()}
          </Button>
        ) : props.title == t('ApplicationsManage') ? (
          <Button
            className={classes.button}
            variant={'contained'}
            onClick={() => navigate(URL_APPLICATION_NEW)}
            style={{ float: 'right' }}>
            {t('newRequest').toUpperCase()}
          </Button>
        ) : props.title == t('Help') ? (
          <Button
            className={classes.button}
            variant={'contained'}
            onClick={() => navigate(URL_CONTACT)}
            style={{ float: 'right' }}>
            {t('contact').toUpperCase()}
          </Button>
        ) : props.title == t('contact') ? (
          <Button
            className={classes.button}
            variant={'contained'}
            onClick={() => navigate(URL_HELP)}
            style={{ float: 'right' }}>
            {t('backToHelp').toUpperCase()}
          </Button>
        ) : props.title == t('clients') ? (
          <Button
            className={classes.button}
            variant={'contained'}
            onClick={handleClientsButton}
            style={{ float: 'right' }}>
            {props.fatherId ? t('newClinic').toUpperCase() : t('newClients').toUpperCase()}
          </Button>
        ) : (
          <></>
        )}
      </div>
      <Divider className={classes.divider} />
    </>
  )
}

const useStyles = makeStyles<Theme, TitleProps>((theme: Theme) => ({
  title: (props) => ({
    color: props.color,
    fontSize: 38,
    paddingBottom: theme.spacing(0),
    marginLeft: '10px',
  }),
  divider: {
    marginBottom: theme.spacing(4),
  },
  button: { backgroundColor: COLOR_PRIMARY, color: 'white' },
      buttonSecondary: {
    color: theme.palette.common.white,
    background: theme.palette.grey['700'],
    border: 0,

  },
  header: { display: 'flex', justifyContent: 'space-between', marginBottom: '10px' },
  headerImage: { display: 'flex', justifyContent: 'left' },
}))
